import axios from 'axios'

export const state = {
  discounts: [],
}

export const getters = {
  getDiscounts(state) {
    return state.discounts
  },
}

export const mutations = {
  SET_DISCOUNTS(state, newValue) {
    state.discounts = newValue
  },
}

export const actions = {
  insertDiscount({ commit, state }, { params: discountDetails }) {
    return axios.post(`v1/discounts/`, discountDetails).then(response => {
      return response.data
    })
  },
  updateDiscount({ commit, state }, { params: discountObj }) {
    return axios.put(`v1/discounts/`, discountObj).then(response => {
      return response.data
    })
  },
  fetchDiscounts({ commit, state }, { groupId, outlets }) {
    let params = {
      group_id: groupId,
      outlets: outlets,
    }
    return axios.get(`v1/discounts/`, { params: params }).then(response => {
      commit('SET_DISCOUNTS', response.data)
      return response.data
    })
  },
  deleteDiscountDocument(
    { commit, state },
    { documentId: discountDocumentId, rev: discountRoleDocumentRev }
  ) {
    return axios
      .delete(`/v1/discounts/${discountDocumentId}/${discountRoleDocumentRev}`)
      .then(response => {
        return response.data
      })
  },
}
